import { z } from "zod";
import { nameSchema, passwordSchema } from "./admin.js";
import { idSchema, isoTimestampSchema } from "./common.js";

// Profile self-service: name (password users), password change, own sessions.

export const updateMeBodySchema = z.object({ name: nameSchema });
export type UpdateMeBody = z.infer<typeof updateMeBodySchema>;

export const changePasswordBodySchema = z.object({
  current: z.string().min(1).max(200),
  next: passwordSchema,
});
export type ChangePasswordBody = z.infer<typeof changePasswordBodySchema>;

export const sessionSchema = z.object({
  id: z.string(),
  userAgent: z.string().nullable(),
  createdAt: isoTimestampSchema,
  lastSeenAt: isoTimestampSchema.nullable(),
  expiresAt: isoTimestampSchema,
  // The session of the request itself (cannot be revoked here; use logout).
  current: z.boolean(),
});
export type Session = z.infer<typeof sessionSchema>;

export const sessionsResponseSchema = z.object({ sessions: z.array(sessionSchema) });
export type SessionsResponse = z.infer<typeof sessionsResponseSchema>;

export const sessionIdParamsSchema = z.object({ id: idSchema });
